/**
 * UTM tagging helpers — mirror of /app/backend/utm.py.
 * Google Analytics 4 will pick these params up automatically once GA_ID is wired.
 */

/**
 * Build a UTM-tagged share URL.
 *
 * @param {string} baseUrl       full URL (with host) of the entity, e.g. "https://mujeres-motor.com/stories/ana-rivera"
 * @param {object} opts
 * @param {string} opts.type     entity type slug ("stories" | "podcast" | "events" | "resources")
 * @param {string} opts.slug     entity slug
 * @param {string} opts.channel  utm_source value (twitter, linkedin, whatsapp, facebook, copy_link, email…)
 * @param {string} [opts.sponsorSlug]  utm_content value (optional)
 * @param {string} [opts.medium="social"]
 * @returns {string}
 */
export function buildShareUrl(baseUrl, { type, slug, channel, sponsorSlug, medium = "social" }) {
  const params = new URLSearchParams({
    utm_source: channel,
    utm_medium: medium,
    utm_campaign: `${type}-${slug}`,
  });
  if (sponsorSlug) params.set("utm_content", sponsorSlug);
  const sep = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${sep}${params.toString()}`;
}
